import { LANGUAGE_COOKIE_NAME } from '../constants';

const COOKIE_MAX_AGE_DAYS = 365;

// getCookieDomain returns the shared parent domain so the language cookie is readable
// across every CrowdRiff subdomain, falling back to a host-only cookie for single-label hosts.
const getCookieDomain = (hostname: string): string | undefined => {
  const labels = hostname.split('.');
  if (labels.length < 2) return undefined;
  return labels.slice(-2).join('.');
};

// setLanguagePreference stores the language code in a cookie shared across CrowdRiff apps.
export const setLanguagePreference = (language: string): void => {
  if (typeof document === 'undefined') return;
  const domain = getCookieDomain(window.location.hostname);
  const secure = window.location.protocol === 'https:';
  const maxAge = COOKIE_MAX_AGE_DAYS * 24 * 60 * 60;
  const parts = [
    `${LANGUAGE_COOKIE_NAME}=${encodeURIComponent(language)}`,
    'path=/',
    'samesite=lax',
    `max-age=${maxAge}`,
  ];
  if (domain) parts.push(`domain=${domain}`);
  if (secure) parts.push('secure');
  document.cookie = parts.join('; ');
};
